export const DEFAULT_ERROR_MESSAGE =
  '<b>Something went wrong.</b> A mistake has occurred and we are working on fixing it.';
